import { css } from "styled-components";
const TRANSITION_DURATION = 800;
export const SlideFromLeftCSSTransitionProps = {
    classNames: "slideFromLeft",
    timeout: { enter: TRANSITION_DURATION, exit: TRANSITION_DURATION },
};
export const SlideFromLeftCSSTransitionCSSMixin = css `
    &.slideFromLeft-enter {
        transform: translateX(-100%);
    }

    &.slideFromLeft-enter.slideFromLeft-enter-active {
        transform: translateX(0);
        transition: transform ${TRANSITION_DURATION}ms ease-in;
    }

    &.slideFromLeft-exit {
        transform: translateX(0);
    }

    &.slideFromLeft-exit.slideFromLeft-exit-active {
        transform: translateX(-100%);
        transition: transform ${TRANSITION_DURATION}ms ease-in;
    }
`;
